import Login from './Login';
import Route from './route';
import * as Constants from './constants';

export default {
  RenderProp: Login,
  mainRoute: Route,
  constants: Constants,
};
